<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? `Add ${page}` : `Edit ${page}`}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? `Add ${page}`  : `Edit ${page}`}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Page</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="cityAddForm" id="cityAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <b-tab :title="language.code" v-for="(language, i) in languages" :key="i">
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'name[' + language.code + ']'" class="form-label">Title:</label>
                      <input :id="'name[' + language.code + ']'" class="form-control" :name="'title_l[' + language.code + ']'" v-model="formData.title_l[language.code]" :class="checkValidation(classes, language.code)" placeholder="title" type="text">
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }" tag="div" class="form-group">
                      <label :for="`description_l[${language.code}]`" class="form-label">Description:</label>
                      <ckeditor :class="checkValidation(classes, language.code)" v-model="formData.description_l[language.code]"   :name="`description_l[${language.code}]`"  :id="`description_l[${language.code}]`" :config="ckEditorConfig"></ckeditor>
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }" tag="div" class="form-group">
                      <label :for="`geography_l[${language.code}]`" class="form-label">Geography:</label>
                      <ckeditor :class="checkValidation(classes, language.code)" v-model="formData.geography_l[language.code]"   :name="`geography_l[${language.code}]`"  :id="`geography_l[${language.code}]`" :config="ckEditorConfig"></ckeditor>
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }" tag="div" class="form-group">
                      <label :for="`article_l[${language.code}]`" class="form-label">Article:</label>
                      <ckeditor :class="checkValidation(classes, language.code)" v-model="formData.article_l[language.code]"   :name="`article_l[${language.code}]`"  :id="`article_l[${language.code}]`" :config="ckEditorConfig"></ckeditor>
                    </ValidationProvider>
                  </b-tab>
                  <ValidationProvider rules="" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="external_code" class="form-label">External Code:</label>
                    <input id="external_code" class="form-control" name="external_code" v-model="formData.external_code" placeholder="external code" :class="classes" type="text">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="d-flex align-items-center mb-3">
                    <label for="code" class="form-label">Show in best deals:</label>
                    <input id="code" class="ml-5 wd-25 ht-25" v-model="formData.show_in_best_deals" placeholder="title" :class="classes" type="checkbox">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="continent_id" class="form-label">Regions:</label>
                    <multiselect v-model="formData.region" placeholder="Select City" :custom-label="customLabel" id="continent_id" :class="classes"  :close-on-select="true" track-by="id" :options="regions">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.title_l[$i18n.locale]}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.title_l[$i18n.locale]}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                  <label class="form-label">
                    Address
                    <br/>
                    <gmap-autocomplete
                      ref="autocomplete"
                      :selectFirstOnEnter="true"
                      class="form-control"
                      :value="formData.address"
                      @place_changed="searchAddressDone">
                    </gmap-autocomplete>
                  </label>
                  <gmap-map
                    :center="map.center"
                    :zoom="map.zoom"
                    map-type-id="terrain"
                    style="width: 100%; height: 300px"
                  >
                    <gmap-marker
                      :position="map.center"
                      :clickable="true"
                      :draggable="true"
                      @dragend="dragendMapMarker"
                    />
                  </gmap-map>
                  <ImageUpload accept="image/png,image/jpeg,image/jpg" label="Image:" page="media" @set-multiple-file="(file) => multipleFiles.push(file)" @hide-multiple-file="(id) => multipleFiles = multipleFiles.filter(item =>  item.multipleId !== id)" :isMultiple="true" name="" uploadType="images" type="image" :filesData="formData.media" />
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ImageUpload from '../../../components/ImageUpload'
const page = 'city'
export default {
  name: 'CityAdd',
  components: {
    ImageUpload
  },
  data () {
    return {
      map: {
        position: { lat: 51.093048, lng: 6.842120 },
        center: { lat: 51.093048, lng: 6.842120 },
        zoom: 8
      },
      page: page,
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      multipleFiles: [],
      regions: [],
      formData: {
        show_in_best_deals: false,
        title_l: {},
        description_l: {},
        geography_l: {},
        article_l: {},
        geo: {
          latitude: 51.093048,
          longitude: 6.842120
        }
      },
      isCreate: false,
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state[page].itemData
    })
  },
  created () {
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.showVideo = true
        this.formData = this.itemData
        this.changeAddress({
          lat: +this.formData.geo.latitude,
          lng: +this.formData.geo.longitude
        }, 17)
      })
    }
    this.getCreateData().then((res) => {
      this.regions = res
    })
  },
  methods: {
    ...mapActions({
      create: page + '/create',
      update: page + '/update',
      getCreateData: page + '/getCreateData',
      getData: page + '/getData'
    }),
    customLabel (data) {
      return `${data.title_l[this.$i18n.locale]}`
    },
    checkValidation (data) {
      return data
    },
    dragendMapMarker (place) {
      this.formData.address = place.formatted_address
      this.changeAddress({
        lat: place.latLng.lat(),
        lng: place.latLng.lng()
      })
      this.$refs.autocomplete.$el.value = ''
    },
    searchAddressDone (place) {
      this.formData.address = place.formatted_address
      this.changeAddress({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      }, 17)
    },
    changeAddress (place, zoom = null) {
      this.map.center = place
      this.map.position = place
      if (zoom) { this.map.zoom = zoom }
    },
    formSubmit () {
      this.$refs.cityAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          const form = document.getElementById('cityAddForm')
          const formData = new FormData(form)
          this.multipleFiles.map((item) => {
            formData.append('media[]', item)
          })
          formData.append('region_id', this.formData.region.id)
          formData.append('address', this.formData.address)
          formData.append('geo[latitude]', this.map.center.lat)
          formData.append('geo[longitude]', this.map.center.lng)
          if (this.formData.show_in_best_deals) {
            formData.append('show_in_best_deals', 1)
          } else {
            formData.append('show_in_best_deals', 0)
          }
          if (this.formData.description_l && Object.keys(this.formData.description_l).length) {
            Object.entries(this.formData.description_l).map(([code, val], i) => {
              formData.append(`description_l[${code}]`, val)
            })
          }
          if (this.formData.geography_l && Object.keys(this.formData.geography_l).length) {
            Object.entries(this.formData.geography_l).map(([code, val], i) => {
              formData.append(`geography_l[${code}]`, val)
            })
          }
          if (this.formData.article_l && Object.keys(this.formData.article_l).length) {
            Object.entries(this.formData.article_l).map(([code, val], i) => {
              formData.append(`article_l[${code}]`, val)
            })
          }
          if (this.isCreate === true) {
            this.create(formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/' + page)
            }).catch((err) => {
              if (err.response.status === 422) {
                const errors = err.response.data
                this.$toasted.error(errors[Object.keys(errors)[0]]).goAway(2500)
                return false
              } else {
                this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            formData.append('_method', 'PUT')
            this.update({ data: formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/' + page)
            }).catch(() => {
              this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
